import type { CeoBankPayment } from '@shared/api';
import { Badge } from '@shared/ui/Badge';
import { formatDateRu, formatMoney, PAYMENT_CATEGORY_LABELS } from '../ceoFormat';
import {
  AccountMonoText,
  AmountCell,
  CounterpartyInnText,
  CounterpartyNameText,
  DocDateText,
  DocNumberText,
  PurposeCell,
  SourceText,
  Table,
  TableWrap,
} from './styles';

interface DailyPaymentsTableProps {
  payments: CeoBankPayment[];
}

export function DailyPaymentsTable({ payments }: DailyPaymentsTableProps) {
  return (
    <TableWrap>
      <Table>
        <thead>
          <tr>
            <th>Дата / Документ</th>
            <th>Банковский счёт</th>
            <th>Контрагент</th>
            <th>Назначение платежа</th>
            <th>Категория ДДС</th>
            <th>Сумма</th>
            <th>Источник</th>
          </tr>
        </thead>
        <tbody>
          {payments.map((p) => (
            <tr key={p.id}>
              <td>
                <DocDateText>{formatDateRu(p.payment_date)}</DocDateText>
                <DocNumberText>{p.document_number ?? '—'}</DocNumberText>
              </td>
              <td>
                <div>{p.bank_name ?? 'Счёт компании'}</div>
                <AccountMonoText>{p.account_number ?? ''}</AccountMonoText>
              </td>
              <td>
                <CounterpartyNameText>{p.counterparty_name}</CounterpartyNameText>
                {p.counterparty_inn && (
                  <CounterpartyInnText>ИНН {p.counterparty_inn}</CounterpartyInnText>
                )}
              </td>
              <PurposeCell>
                <div>{p.purpose}</div>
                {p.ks3_reference && <Badge $tone="info">{p.ks3_reference}</Badge>}
              </PurposeCell>
              <td>
                <Badge
                  $tone={
                    p.category === 'internal_transfer'
                      ? 'info'
                      : p.direction === 'inflow'
                        ? 'success'
                        : 'neutral'
                  }
                >
                  {PAYMENT_CATEGORY_LABELS[p.category] ?? p.category}
                </Badge>
              </td>
              <AmountCell $direction={p.direction}>
                {p.direction === 'inflow' ? '+' : '−'}
                {formatMoney(p.amount)}
              </AmountCell>
              <td>
                <SourceText>{p.source}</SourceText>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </TableWrap>
  );
}
